import { ThemeProvider } from 'contexts/ThemeProvider';

import type { FC, ReactNode } from 'react';

interface GlobalWrapperProps {
  children: ReactNode;
}

const GlobalLayout: FC<GlobalWrapperProps> = ({ children }) => <ThemeProvider>{children}</ThemeProvider>;
export default GlobalLayout;
